import AccessToken from './accessToken';
import Profile from './profile';
import UserProfile from './portalUserProfiles';

const apis = {
  AccessToken,
  Profile,
  UserProfile,
};

export default apis;
